export const getValueOrDefault = (key, fallback) => {
  const value = localStorage.getItem(key);
  if (!value || value === "null") {
    return fallback;
  }
  return value;
}